import { render, staticRenderFns } from "./vipIndex.vue?vue&type=template&id=d215c52a&scoped=true"
import script from "./vipIndex.vue?vue&type=script&lang=js"
export * from "./vipIndex.vue?vue&type=script&lang=js"
import style0 from "./vipIndex.vue?vue&type=style&index=0&id=d215c52a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d215c52a",
  null
  
)

export default component.exports